import { Route } from '@angular/compiler/src/core';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  displayOffset: boolean = false;
  activeRoute: string = '';
  currentYear = new Date().getFullYear();
  constructor(private router: Router) {
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.activeRoute = event['url'];
      if (this.activeRoute.includes('/pre-retirement-costs')) {
        this.displayOffset = true;
      }
    });    
  }


  ngOnInit(): void {
  }

}
